"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variableNodeSpec = exports.variableNodeView = exports.createInsertVariablesTool = exports.variableNodeName = void 0;
const insertTools_1 = require("./insertTools");
const ll_1 = require("../../languages/ll");
exports.variableNodeName = "variable";
exports.createInsertVariablesTool = (settings) => insertTools_1.createInsertTool({
    nodeType: exports.variableNodeName,
    getTextToInsert: (item) => item.code,
    attrs: code => ({ name: code }),
    title: settings.title || "",
    props: settings.props,
    items: settings.items
});
function getDeleteButtonElement(view, getPos) {
    const deleteButtonOuterSpan = document.createElement("span");
    deleteButtonOuterSpan.setAttribute("aria-label", "delete");
    deleteButtonOuterSpan.classList.add("k-select");
    const deleteButtonInnerSpan = document.createElement("span");
    deleteButtonInnerSpan.classList.add("k-icon");
    deleteButtonInnerSpan.classList.add("k-i-close");
    deleteButtonInnerSpan.onclick = event => {
        let position = typeof getPos === "function" ? getPos() : null;
        if (position !== null) {
            view.dispatch(view.state.tr.deleteRange(position, position + 1));
        }
    };
    deleteButtonOuterSpan.appendChild(deleteButtonInnerSpan);
    return deleteButtonOuterSpan;
}
function getVariableBubbleElement(label) {
    const element = document.createElement("span");
    element.appendChild(document.createTextNode(label));
    return element;
}
function getVariableNode(node) {
    const variableNode = document.createElement("v");
    variableNode.setAttribute("variable-name", node.attrs.name);
    variableNode.setAttribute("selected", node.attrs.selected);
    variableNode.setAttribute("title", node.attrs.name);
    variableNode.classList.add("variable-bubble");
    return variableNode;
}
function buildVariableNode(node, view, getPos) {
    const localizedName = ll_1.ll(node.attrs.name);
    const variableElement = getVariableBubbleElement(localizedName);
    const variableNode = getVariableNode(node);
    const deleteButton = getDeleteButtonElement(view, getPos);
    variableElement.appendChild(deleteButton);
    variableNode.appendChild(variableElement);
    return variableNode;
}
const nodeViews = {
    variable: (node, view, getPos) => {
        const variableNode = buildVariableNode(node, view, getPos);
        return {
            dom: variableNode
        };
    }
};
exports.variableNodeView = nodeViews && nodeViews.variable;
exports.variableNodeSpec = {
    attrs: { name: { default: "" }, selected: { default: "false" } },
    inline: true,
    group: "inline",
    draggable: true,
    selectable: true,
    marks: "",
    atom: true,
    toDOM: nodeViews.variable,
    parseDOM: [
        {
            tag: "v",
            getAttrs: (dom) => {
                let name = dom.getAttribute("variable-name");
                return name ? { name } : false;
            }
        }
    ]
};
//# sourceMappingURL=variableNodes.js.map